import styles from './GradientBackground.module.css'
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ThpaceGL } from "thpace";


const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
};

const GradientBackground = () => {
  const canvasRef = useRef(null);
  const location = useLocation();

  const [settings] = useState({
    colors: ["#9633ff", "#5400ad", '#270066', "#000000"],
    triangleSize: 80,
    bleed: 100,
    automaticResize: false,
    pointAnimationSpeed: 11000,
    noise: 50,
    particleSettings: {
      color: "white",
      count: [1, 3],
      radius: [0.5, 2],
    }
  });

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: document.documentElement.scrollHeight,
  });

  useEffect(() => {
    const updateSize = function () {
      if (dimensions.width === window.innerWidth && dimensions.height === window.innerHeight) return;
      debounce(() => {
        setDimensions({
          width: window.innerWidth,
          height: document.documentElement.scrollHeight,
        });
      }, 200);
    }

    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, [dimensions]);

  useEffect(() => {
    setDimensions({
      width: window.innerWidth,
      height: document.documentElement.scrollHeight,
    });
  }, [location.pathname]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.width = dimensions.width;
      canvas.height = dimensions.height;

      ThpaceGL.create(canvas, settings);
    }
  }, [dimensions, settings]);


  return (
    <canvas
      className={styles.GradientBackground}
      ref={canvasRef}
    />
  );
};

export default GradientBackground;